<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <div class="container">
        <div class="mb-4">
          <div v-if="!showRemoveButton" class="text-danger">ประกาศถูกลบ</div>
          <sc-button
            v-if="showRemoveButton"
            variant="danger"
            @click="handleClickRemove"
            >ลบประกาศ</sc-button
          >
        </div>
        <div
          v-if="$route.params.id"
          class="text-end mt-4"
        >
          <language-select
            v-model="language"
            @change="handleChangeLanguage"
          ></language-select>
        </div>
        <notice-editor v-model="form" :language="language"></notice-editor>
        <div class="text-end mt-4">
          <sc-button variant="primary" @click="handleClickSave"
            >บันทึก</sc-button
          >
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import LanguageSelect from "@/lib/components/LanguageSelect";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { localization } from "@/lib/mapper";

import { MessageBox } from "element-ui";
import { DateTime } from "luxon";

import NoticeEditor from "../components/NoticeEditor";

export default {
  components: {
    PageWrapper,
    ScButton,
    NoticeEditor,
    LanguageSelect
  },
  data() {
    const title = "รายละเอียดประกาศ";
    const form = {
      title: "",
      subtitle: "",
      projects: [],
      publishDate: null,
      calendarDate: null,
    };
    const notice = null;

    return {
      notice,
      title,
      form,
      language: localization.TH
    };
  },
  computed: {
    showRemoveButton() {
      return Boolean(this.notice && !this.notice.delete_at);
    }
  },
  created() {
    this.setupData();
  },
  methods: {
    async setupData() {
      try {
        const result = await this.fetchData();

        const { title, subtitle } = result;
        const projects = result.project_ids.map(projectId => ({ projectId }));
        const publishDate = {
          start: DateTime.fromISO(result.published_start_at),
          end: DateTime.fromISO(result.published_end_at)
        };
        const calendarDate = (result.start_at !== null)
          ? {
            start: DateTime.fromISO(result.start_at),
            end: DateTime.fromISO(result.end_at)
          }
          : undefined;

        this.notice = result;
        this.form = {
          title,
          subtitle,
          projects,
          publishDate,
          calendarDate
        };
      } catch (err) {
        this.$message.error("ไม่สามารถโหลดข้อมูลประกาศได้");
      }
    },
    async fetchData() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.communications.notices.get(
        id, this.language
      );

      return response.data.result;
    },
    async handleClickSave() {
      try {
        await this.updateNotice();
        this.$router.push({ name: "NoticeListPage" });
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async updateNotice() {
      const { title, projects, subtitle, publishDate, calendarDate } = this.form;

      const projectIds = projects.map(({ projectId }) => projectId);
      const { id } = this.$route.params;
      let response
      if (this.language === localization.TH) {
        const params = {
          title,
          subtitle,
          projectIds,
          publishDate: {
            start: publishDate.start.toISO(),
            end: publishDate.end.toISO()
          },
          calendarDate: calendarDate != null
            ? {
              start: calendarDate.start.toISO(),
              end: calendarDate.end.toISO()
            }
            : undefined
        };

        response = await baanRueJaiClient.admin.communications.notices.put(
          id,
          params
        );
      } else {
        const params = {
          title,
          subtitle
        }
        response = await baanRueJaiClient.admin.communications.notices.putLanguage(
          id,
          params,
          this.language
        );
      }

      return response.data.result;
    },
    async handleClickRemove() {
      try {
        await MessageBox.confirm("ยืนยันการลบประกาศ", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก"
        });
      } catch (err) {
        return;
      }

      try {
        await this.removeNotice();
        this.$message.success("ลบเรียบร้อย");
        this.$router.push({ name: "NoticeListPage" });
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async removeNotice() {
      const { id } = this.$route.params;

      await baanRueJaiClient.admin.communications.notices.delete(id);
    },
    handleChangeLanguage() {
      this.setupData();
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
